export class Integration {
  webhookUrl: string = "";
  apiToken: string = "";
}

export class ApiToken {
  apiToken: string = "";
}
